import { InternalLink } from '../../../components/Clickables/InternalLink/InternalLink';
import { Container } from '../../../components/Container/Container';
import { Heading } from '../../../components/Heading/Heading';
import { CheckoutIcon } from '../../../components/Icons/CheckoutIcon';
import { Text } from '../../../components/Text/Text';
import { getFishingWaterUrl } from '../../../helpers/urls';

interface IProps {
  isNotAppPage: boolean;
  fishingWater: {
    externalId: string;
    name: string;
  };
  isNewForm?: boolean;
}

export const SuggestionSuccess = ({ isNotAppPage, fishingWater, isNewForm = false }: IProps) => {
  return (
    <>
      <Container
        className="mt-10 flex flex-col items-center gap-4 text-center md:mt-14"
        variant="thin"
      >
        <CheckoutIcon size={80} />
        <Heading variant="sm">Changes submitted</Heading>
        <div className="w-full">
          <Text variant="sm">
            Thanks for submitting your suggestions, we&apos;ll review them shortly. Keep an eye on
            your email as we&apos;ll be in contact to confirm the details of your suggestion.
          </Text>
        </div>
        {isNotAppPage && !isNewForm && (
          <InternalLink
            variant="buttonPrimary"
            className="max-w-prose"
            to={getFishingWaterUrl(fishingWater.externalId, fishingWater.name)}
          >
            Back to {fishingWater.name}
          </InternalLink>
        )}
      </Container>
      {/* User Interview is off temporarily */}
      {/* <UserInterviewSection className="mt-8" /> */}
    </>
  );
};
